/* ============================================================
   BUY'NBYE — Theme JavaScript v1.0
   ============================================================ */

/* ── CART DRAWER ───────────────────────────────── */
const cartDrawer  = document.getElementById('cart-drawer');
const cartOverlay = document.getElementById('cart-overlay');

function openCart()  {
  cartDrawer?.classList.add('open');
  cartOverlay?.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  cartDrawer?.classList.remove('open');
  cartOverlay?.classList.remove('open');
  document.body.style.overflow = '';
}

document.querySelectorAll('[data-cart-toggle]').forEach(btn => btn.addEventListener('click', openCart));
cartOverlay?.addEventListener('click', closeCart);
document.querySelectorAll('[data-cart-close]').forEach(btn => btn.addEventListener('click', closeCart));

/* ── ADD TO CART ───────────────────────────────── */
async function addToCart(variantId, quantity = 1) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  });
  const data = await res.json();
  if (res.ok) {
    updateCartCount();
    openCart();
    await refreshCartDrawer();
  } else {
    alert(data.description || 'Could not add item to cart.');
  }
  return data;
}

document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
  btn.addEventListener('click', async (e) => {
    const variantId = btn.dataset.variantId || btn.closest('[data-variant-id]')?.dataset.variantId;
    if (!variantId) return;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    await addToCart(variantId);
    btn.disabled = false;
    btn.textContent = btn.dataset.originalText || 'Add to Bag';
  });
});

/* ── CART COUNT ───────────────────────────────── */
async function updateCartCount() {
  const res  = await fetch('/cart.js');
  const data = await res.json();
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = data.item_count;
    el.style.display = data.item_count > 0 ? 'flex' : 'none';
  });
}
updateCartCount();

/* ── CART DRAWER REFRESH ───────────────────────────── */
async function refreshCartDrawer() {
  const res  = await fetch('/cart?sections=cart-drawer-items');
  const data = await res.json();
  const html = data['cart-drawer-items'];
  if (html) {
    const wrapper = document.getElementById('cart-drawer-items');
    if (wrapper) wrapper.innerHTML = html;
  }
}

/* ── QTY BUTTONS ───────────────────────────────── */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-qty-change]');
  if (!btn) return;
  const key   = btn.dataset.lineKey;
  const delta = parseInt(btn.dataset.qtyChange);
  const input = btn.parentElement.querySelector('.qty-val');
  const current = parseInt(input?.textContent || '1');
  const newQty  = Math.max(0, current + delta);
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: newQty })
  });
  updateCartCount();
  refreshCartDrawer();
});

/* ── MOBILE NAV ───────────────────────────────── */
const mobileNav    = document.getElementById('mobile-nav');
const mobileToggle = document.querySelector('[data-mobile-nav-toggle]');
const mobileClose  = document.querySelector('[data-mobile-nav-close]');

mobileToggle?.addEventListener('click', () => {
  mobileNav?.classList.add('open');
  document.body.style.overflow = 'hidden';
});
mobileClose?.addEventListener('click', () => {
  mobileNav?.classList.remove('open');
  document.body.style.overflow = '';
});

/* ── STICKY HEADER ───────────────────────────────── */
const header = document.querySelector('.site-header');
window.addEventListener('scroll', () => {
  header?.classList.toggle('scrolled', window.scrollY > 20);
}, { passive: true });

/* ── WISHLIST (localStorage) ───────────────────── */
let wishlist = JSON.parse(localStorage.getItem('buynbye_wishlist') || '[]');

function toggleWishlist(productId, btn) {
  const idx = wishlist.indexOf(productId);
  if (idx === -1) { wishlist.push(productId); btn?.classList.add('active'); }
  else            { wishlist.splice(idx, 1);  btn?.classList.remove('active'); }
  localStorage.setItem('buynbye_wishlist', JSON.stringify(wishlist));
}

document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
  const id = btn.dataset.wishlistToggle;
  if (wishlist.includes(id)) btn.classList.add('active');
  btn.addEventListener('click', () => toggleWishlist(id, btn));
});

/* ── REVEAL ON SCROLL ────────────────────────────── */
const revealObs = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); revealObs.unobserve(e.target); } });
}, { threshold: 0.1 });
document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));

/* ── PRODUCT GALLERY ─────────────────────────────── */
document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    const mainWrapper = thumb.closest('.product-gallery')?.querySelector('.product-gallery__main');
    const mainImg = mainWrapper?.querySelector('img');
    const thumbImg = thumb.querySelector('img');
    if (mainImg && thumbImg) {
      const fullSrc = thumb.dataset.fullSrc || thumbImg.src
        .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024|2048x2048|master)(\.[a-z]+)(\?.*)?$/, '_1000x$2')
        .replace(/(\.[a-z]+)(\?.*)?$/, (m, ext, q) => ext + (q||''));
      mainImg.style.opacity = '0.6';
      mainImg.style.transition = 'opacity 0.2s';
      const newImg = new Image();
      newImg.onload = () => {
        mainImg.src = newImg.src;
        mainImg.style.opacity = '1';
      };
      newImg.src = fullSrc;
    }
    thumb.closest('.product-gallery')?.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

/* ── VARIANT SELECTOR ───────────────────────────── */
document.querySelectorAll('.variant-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.closest('.variant-options')?.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const form = btn.closest('form');
    const hiddenVariant = form?.querySelector('[name="id"]');
    if (hiddenVariant && btn.dataset.variantId) hiddenVariant.value = btn.dataset.variantId;
  });
});

/* ── NEWSLETTER FORM ──────────────────────────── */
document.querySelector('.newsletter-form')?.addEventListener('submit', async (e) => {
  e.preventDefault();
  const email = e.target.querySelector('input[type="email"]').value;
  const btn   = e.target.querySelector('button');
  btn.textContent = 'Subscribing...';
  btn.disabled = true;
  try {
    const res = await fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: `form_type=customer&utf8=✓&contact[email]=${encodeURIComponent(email)}&contact[tags]=newsletter`
    });
    btn.textContent = '✓ Subscribed!';
  } catch {
    btn.textContent = 'Try again';
    btn.disabled = false;
  }
});

/* ── ANNOUNCEMENT BAR CLOSE ──────────────────────── */
document.querySelector('[data-announcement-close]')?.addEventListener('click', (e) => {
  e.target.closest('.announcement-bar')?.remove();
  sessionStorage.setItem('announcement_closed', '1');
});
if (sessionStorage.getItem('announcement_closed')) {
  document.querySelector('.announcement-bar')?.remove();
}

/* ── PRODUCT CARD SWIPE SLIDERS ───────────────────── */
function initCardSliders() {
  document.querySelectorAll('.pc-slider:not([data-init])').forEach(function(slider) {
    slider.setAttribute('data-init', '1');

    var track  = slider.querySelector('.pc-slider__track');
    var slides = slider.querySelectorAll('.pc-slider__slide');
    var dots   = slider.querySelectorAll('.pc-slider__dot');
    var total  = slides.length;
    if (total <= 1) return;

    var current    = 0;
    var startX     = 0;
    var startY     = 0;
    var dragging   = false;
    var lockAxis   = null;
    var THRESHOLD  = 35;

    function goTo(index) {
      if (index < 0) index = 0;
      if (index >= total) index = total - 1;
      current = index;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      slider.style.touchAction = 'pan-y';
      dots.forEach(function(d, i) { d.classList.toggle('active', i === current); });
    }

    slider.addEventListener('touchstart', function(e) {
      startX   = e.touches[0].clientX;
      startY   = e.touches[0].clientY;
      dragging = true;
      lockAxis = null;
      track.style.transition = 'none';
    }, { passive: true });

    slider.addEventListener('touchmove', function(e) {
      if (!dragging) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;

      if (!lockAxis && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
        lockAxis = Math.abs(dx) >= Math.abs(dy) ? 'h' : 'v';
      }

      if (lockAxis === 'v') {
        dragging = false;
        track.style.transition = '';
        slider.style.touchAction = 'pan-y';
        return;
      }

      if (lockAxis === 'h') {
        slider.style.touchAction = 'none';
        e.preventDefault();
        var pct = (current * -100);
        track.style.transform = 'translateX(calc(' + pct + '% + ' + dx + 'px))';
      }
    }, { passive: false });

    slider.addEventListener('touchend', function(e) {
      if (!dragging) return;
      dragging = false;
      lockAxis = null;
      track.style.transition = '';
      slider.style.touchAction = 'pan-y';
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < Math.abs(dy)) { goTo(current); return; }
      if (dx < -THRESHOLD) goTo(current + 1);
      else if (dx > THRESHOLD) goTo(current - 1);
      else goTo(current);
    }, { passive: true });

    var mouseDown = false;
    var mouseStartX = 0;

    slider.addEventListener('mousedown', function(e) {
      mouseDown   = true;
      mouseStartX = e.clientX;
      track.style.transition = 'none';
      slider.style.cursor = 'grabbing';
      e.preventDefault();
    });

    window.addEventListener('mousemove', function(e) {
      if (!mouseDown) return;
      var dx = e.clientX - mouseStartX;
      var pct = current * -100;
      track.style.transform = 'translateX(calc(' + pct + '% + ' + dx + 'px))';
    });

    window.addEventListener('mouseup', function(e) {
      if (!mouseDown) return;
      mouseDown = false;
      track.style.transition = '';
      slider.style.cursor = '';
      var dx = e.clientX - mouseStartX;
      if (dx < -THRESHOLD) goTo(current + 1);
      else if (dx > THRESHOLD) goTo(current - 1);
      else goTo(current);
    });

    slider.addEventListener('click', function(e) {
      var dx = Math.abs(e.clientX - mouseStartX);
      if (dx > 5) e.preventDefault();
    }, true);

    goTo(0);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCardSliders);
} else {
  initCardSliders();
}

var sliderObs = new MutationObserver(function() { initCardSliders(); });
sliderObs.observe(document.body, { childList: true, subtree: true });
